import styled from 'vue-styled-components';

import { GRAY, FLEX_CENTER } from '@/styles/common.styled';

export const ComponentWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    padding: 11px 16px;
    border: 1px solid ${GRAY(20)};
    border-radius: 2px;
    background-color: ${GRAY(10)};

    .top-wrapper {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
            ${FLEX_CENTER}
            padding: 0;
            margin: 0;

            svg.sort-icon {
                width: 16px;
                height: 16px;
                margin-right: 8px;
            }

            svg.info-line-icon {
                width: 16px;
                height: 16px;
                cursor: pointer;
            }

            h3 {
                flex: 1;
                color: ${GRAY(100)};
                font-size: 14px;
                font-weight: 500;
                margin-right: 8px;
            }
        }
    }
`;
